import { render, staticRenderFns } from "./GrbEditDialog.vue?vue&type=template&id=3fc97a58&scoped=true&"
import script from "./GrbEditDialog.vue?vue&type=script&lang=js&"
export * from "./GrbEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc97a58",
  null
  
)

export default component.exports